module.exports = __webpack_public_path__ + "img/2cf7b5ff763f47f5b8d8ad3da29f963b.f15aebc2.png";